import React, { useState, useEffect, useRef } from "react";
import LoaderIndex from "~/containers/LoaderIndex";
import { Link } from "../Elements";
import { FacebookEmbed, InstagramEmbed, YouTubeEmbed } from 'react-social-media-embed';
const tasrTVVideaURL = "https://www.youtube.com/c/TASRTV";
const terazIgURL = "https://www.instagram.com/terazsk/";
const TerazFBUrl = "https://www.facebook.com/teraz.sk";
const tasrFBUrl = "https://www.facebook.com/AgenturaTASR";
const tasrIgURL = "https://www.instagram.com/tasr_thenewsagency/";
const terazSCURL = "https://soundcloud.com/terazsk";
const terazThreadsURL = "https://www.threads.net/@terazsk";

// import LoaderIndex from "../../containers/LoaderIndex"


const SpotifyPlayer = ({ embedUrl }) => {

    useEffect(() => {
        if (process.env.BUILD_TARGET !== "server") {
            (window as any).onSpotifyIframeApiReady = (IFrameAPI) => {
                const element = document.getElementById('spotify-embed-iframe');
                const options = {
                    uri: 'spotify:episode:' + embedUrl
                };
                const callback = (EmbedController) => {};
                IFrameAPI.createController(element, options, callback);
            };
        }
    }, []);

    return (
        <div id="spotify-embed-iframe"></div>
    );
  };

  


const AgregatorSocSietiPage = (props) => {
  
    const [searchResults, setSearchResults] = useState([]);
    const [searchVideoResults, setSearchVideoResults] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [searchVideoTerm, setSearchVideoTerm] = useState('');

    const [embeddedFbPost, setEmbeddedFbPost] = useState('');
    const [embeddedIgPost, setEmbeddedIgPost] = useState('');
    const [embeddedYtPost, setEmbeddedYtPost] = useState('');
    const [embeddedSpotifyPost, setEmbeddedSpotifyPost] = useState('');
    const [showPopup, setShowPopup] = useState(false);
    const [showSearchPopup, setShowSearchPopup] = useState(false);


    const [activeVideoFilter, setActiveVideoFilter] = useState('');
    const [activePostFilter, setActivePostFilter] = useState('');
    const [socialData, setSocialData] = useState();
    
    const [ytByViews, setYtByViews] = useState([]);
    const [ytByViewsPage, setYtByViewsPage] = useState(1);
    const [ytByViewsHasMore, setYtByViewsHasMore] = useState(true);
    const [ytByViewsLoading, setYtByViewsLoading] = useState(false);
    const ytByViewsRef = useRef(null);

    const [ytByDate, setYtByDate] = useState([]);
    const [ytByDatePage, setYtByDatePage] = useState(1);
    const [ytByDateHasMore, setYtByDateHasMore] = useState(true);
    const [ytByDateLoading, setYtByDateLoading] = useState(false);
    const ytByDateRef = useRef(null);

    const [spotifyByDate, setSpotifyByDate] = useState([]);
    const [spotifyByDatePage, setSpotifyByDatePage] = useState(1);
    const [spotifyByDateHasMore, setSpotifyByDateHasMore] = useState(true);
    const [spotifyByDateLoading, setSpotifyByDateLoading] = useState(false);
    const spotifyByDateRef = useRef(null);

    const [instagramByDate, setInstagramByDate] = useState([]);
    const [instagramByDatePage, setInstagramByDatePage] = useState(1);
    const [instagramByDateHasMore, setInstagramByDateHasMore] = useState(true);
    const [instagramByDateLoading, setInstagramByDateLoading] = useState(false);
    const instagramByDateRef = useRef(null);

    const [facebookByDate, setFacebookByDate] = useState([]);
    const [facebookByDatePage, setFacebookByDatePage] = useState(1);
    const [facebookByDateHasMore, setFacebookByDateHasMore] = useState(true);
    const [facebookByDateLoading, setFacebookByDateLoading] = useState(false);
    const facebookByDateRef = useRef(null);

    const [facebookByStateInstitution, setFacebookByStateInstitution] = useState([]);
    const [facebookByStateInstitutionPage, setFacebookByStateInstitutionPage] = useState(1);
    const [facebookByStateInstitutionHasMore, setFacebookByStateInstitutionHasMore] = useState(true);
    const [facebookByStateInstitutionLoading, setFacebookByStateInstitutionLoading] = useState(false);
    const facebookByStateInstitutionRef = useRef(null);

    const [youtubeByDateNonParlamentary, setYoutubeByDateNonParlamentary] = useState([]);
    const [youtubeByDateNonParlamentaryPage, setYoutubeByDateNonParlamentaryPage] = useState(1);
    const [youtubeByDateNonParlamentaryHasMore, setYoutubeByDateNonParlamentaryHasMore] = useState(true);
    const [youtubeByDateNonParlamentaryLoading, setYoutubeByDateNonParlamentaryLoading] = useState(false);
    const youtubeByDateNonParlamentaryRef = useRef(null);

    const [facebookByDateNonParlamentary, setFacebookByDateNonParlamentary] = useState([]);
    const [facebookByDateNonParlamentaryPage, setFacebookByDateNonParlamentaryPage] = useState(1);
    const [facebookByDateNonParlamentaryHasMore, setFacebookByDateNonParlamentaryHasMore] = useState(true);
    const [facebookByDateNonParlamentaryLoading, setFacebookByDateNonParlamentaryLoading] = useState(false);
    const facebookByDateNonParlamentaryRef = useRef(null);

    const [instagramByDateNonParlamentary, setInstagramByDateNonParlamentary] = useState([]);
    const [instagramByDateNonParlamentaryPage, setInstagramByDateNonParlamentaryPage] = useState(1);
    const [instagramByDateNonParlamentaryHasMore, setInstagramByDateNonParlamentaryHasMore] = useState(true);
    const [instagramByDateNonParlamentaryLoading, setInstagramByDateNonParlamentaryLoading] = useState(false);
    const instagramByDateNonParlamentaryRef = useRef(null);


    const [searchTermNonParlamentary, setSearchTermNonParlamentary] = useState('');
    const [searchResultsNonParlamentary, setSearchResultsNonParlamentary] = useState([]);

    useEffect(() => {
        if (process.env.BUILD_TARGET !== "server") {
            const urlParams = new URLSearchParams(window.location.search);
            const vyhladatParam = urlParams.get('vyhladat');
            if (vyhladatParam) {
                setShowSearchPopup(true);
                console.log('vyhladatParam', vyhladatParam);
            }
        }
    }, []);

    useEffect(() => {
        const handleScroll = () => {
            if (process.env.BUILD_TARGET !== "server") {
                const innerDiv = document.querySelector('.inner') as HTMLElement;   
                if (innerDiv) {
                    innerDiv.style.marginTop = `${window.scrollY}px`;
                }
            }
        };
        const handleKeyUp = (event: KeyboardEvent) => {
            if (event.key === 'Escape') {
                closePopup();
            }          
        };       

        if (process.env.BUILD_TARGET !== "server") {
            window.addEventListener('keyup', handleKeyUp);
            window.addEventListener('scroll', handleScroll);
        }
        return () => {
            if (process.env.BUILD_TARGET !== "server") {
                window.removeEventListener('scroll', handleScroll);
                window.removeEventListener('keyup', handleKeyUp);
            }
        };
       
    }, []);
    


  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch("https://www.teraz.sk/api/social_network_content/list.php");
        const data = await response.json();
        setSocialData(data);
      } catch (error) {
        console.log(error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    fetchYtByViews(0);
    fetchYtByDate(0);
    fetchSpotifyByDate(0);
    fetchInstagramByDate(0);
    fetchFacebookByDate(0);
    fetchFacebookByStateInstitution(0);
    fetchYtByDateNonParlamentary(0);
    fetchFacebookByDateNonParlamentary(0);
    fetchInstagramByDateNonParlamentary(0);
  }, []);

    const formatDate = (dateString: string): string => {
        const date = new Date(dateString);
        const today = new Date();
        const yesterday = new Date(today);
        yesterday.setDate(yesterday.getDate() - 1);

        // Format time as H:i
        const timeString = date.toLocaleTimeString('sk-SK', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
        });

        if (date.toDateString() === today.toDateString()) {
            return `dnes ${timeString}`;
        } else if (date.toDateString() === yesterday.toDateString()) {
            return `včera ${timeString}`;
        } else {
            return date.toLocaleString('sk-SK', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                hour12: false
            });
        }
    };
  

    function openEmbedPopup(url: string, networkType: string): void {    
        switch (networkType) {
            case 'FACEBOOK':
            case 'STATE_INSTITUTION':
            case 'POLITICAL_PARTY':
                setEmbeddedFbPost(url);
                break;
            case 'INSTAGRAM':
                setEmbeddedIgPost(url);
                break;
            case 'YOUTUBE':
                setEmbeddedYtPost(url);
                break;
            case 'SPOTIFY':
                setEmbeddedSpotifyPost(url);
                break;
            default:
                break;
        }
        setShowPopup(true);
        if (process.env.BUILD_TARGET !== "server") {
            const innerDiv = document.querySelector('.inner') as HTMLElement;
            if (innerDiv) {
                innerDiv.style.marginTop = `${window.scrollY}px`;
            }
        }
    }

    

    function closePopup(): void {        
        setEmbeddedFbPost('');
        setEmbeddedIgPost('');
        setEmbeddedYtPost('');
        setEmbeddedSpotifyPost('');
        setShowPopup(false);
        setShowSearchPopup(false);
    }

    


    function handleFilterToggle(item: string): void {
        setActivePostFilter(item);
    }    
    function handleVideoFilterToggle(item: string): void {
        setActiveVideoFilter(item);
    }    

    const handleSearch = async (searchQuery) => {
        try {
            const response = await fetch(`https://www.teraz.sk/api/social_network_content/list.php?q=${searchQuery}`);
            const data = await response.json();
            
            setSearchTerm(searchQuery);

            // remove youtube from results

            delete data.YOUTUBE;            

            const flatResults = Object.entries(data).reduce((acc, [networkType, items]) => 
                acc.concat(items.by_date.map(item => ({
                    ...item,
                    networkType
                }))), []
            );

            

            setSearchResults(flatResults);
        } catch (error) {
            console.error(error);
        }
    };

    const handleSearchNonParlamentary = async (searchQuery) => {
        try {
            const response = await fetch(`https://www.teraz.sk/api/social_network_content/list.php?q=${searchQuery}`);
            const data = await response.json();
            
            setSearchTermNonParlamentary(searchQuery);

            // remove youtube from results

            delete data.YOUTUBE;            

            const flatResults = Object.entries(data).reduce((acc, [networkType, items]) => 
                acc.concat(items.by_date.map(item => ({
                    ...item,
                    networkType
                }))), []
            );

            

            setSearchResultsNonParlamentary(flatResults);
        } catch (error) {
            console.error(error);
        }
    };

    const handleSearchVideo = async (searchQuery) => {
        try {
            const response = await fetch(`https://www.teraz.sk/api/social_network_content/list.php?q=${searchQuery}`);
            const data = await response.json();
            
            setSearchVideoTerm(searchQuery);

            const flatResults = data.YOUTUBE?.by_date?.map(item => ({
                ...item,
                networkType: "YOUTUBE"
            }))


            setSearchVideoResults(flatResults);
        } catch (error) {
            console.error(error);
        }
    };

    

    const fetchYtByViews = async (page = 1) => {
        setYtByViewsLoading(true);
        try {
            const response = await fetch(`https://www.teraz.sk/api/social_network_content/list.php?pageIdx=${page}`);
            const data = await response.json();
            const newItems = data.YOUTUBE?.by_views || [];
            setYtByViews(prev => [...prev, ...newItems]);
            setYtByViewsHasMore(newItems.length > 0);
            setYtByViewsPage(page);
        } catch (error) {
            setYtByViewsHasMore(false);
        }
        setYtByViewsLoading(false);
    };

    const fetchYtByDate = async (page = 1) => {
        setYtByDateLoading(true);
        try {
            const response = await fetch(`https://www.teraz.sk/api/social_network_content/list.php?pageIdx=${page}`);
            const data = await response.json();
            const newItems = data.YOUTUBE?.by_date || [];
            setYtByDate(prev => [...prev, ...newItems]);
            setYtByDateHasMore(newItems.length > 0);
            setYtByDatePage(page);
        } catch (error) {
            setYtByDateHasMore(false);
        }
        setYtByDateLoading(false);
    };

    const fetchSpotifyByDate = async (page = 1) => {
        setSpotifyByDateLoading(true);
        try {
            const response = await fetch(`https://www.teraz.sk/api/social_network_content/list.php?pageIdx=${page}`);
            const data = await response.json();
            const newItems = data.SPOTIFY?.by_date || [];
            setSpotifyByDate(prev => [...prev, ...newItems]);
            setSpotifyByDateHasMore(newItems.length > 0);
            setSpotifyByDatePage(page);
        } catch (error) {
            setSpotifyByDateHasMore(false);
        }
        setSpotifyByDateLoading(false);
    };

    const fetchInstagramByDate = async (page = 1) => {
        setInstagramByDateLoading(true);
        try {
            const response = await fetch(`https://www.teraz.sk/api/social_network_content/list.php?pageIdx=${page}`);
            const data = await response.json();
            const newItems = data.INSTAGRAM?.by_date || [];
            setInstagramByDate(prev => [...prev, ...newItems]);
            setInstagramByDateHasMore(newItems.length > 0);
            setInstagramByDatePage(page);
        } catch (error) {
            setInstagramByDateHasMore(false);
        }
        setInstagramByDateLoading(false);
    };

    const fetchFacebookByDate = async (page = 1) => {
        setFacebookByDateLoading(true);
        try {
            const response = await fetch(`https://www.teraz.sk/api/social_network_content/list.php?pageIdx=${page}`);
            const data = await response.json();
            const newItems = data.FACEBOOK?.POLITICAL_PARTY?.by_date || [];
            // const newItems = data.FACEBOOK?.by_date || [];
            setFacebookByDate(prev => [...prev, ...newItems]);
            setFacebookByDateHasMore(newItems.length > 0);
            setFacebookByDatePage(page);
        } catch (error) {
            setFacebookByDateHasMore(false);
        }
        setFacebookByDateLoading(false);
    };

    const fetchFacebookByStateInstitution = async (page = 1) => {
        setFacebookByStateInstitutionLoading(true);
        try {
            const response = await fetch(`https://www.teraz.sk/api/social_network_content/list.php?pageIdx=${page}`);
            const data = await response.json();
            const newItems = data.FACEBOOK?.STATE_INSTITUTION?.by_date || [];
            setFacebookByStateInstitution(prev => [...prev, ...newItems]);
            setFacebookByStateInstitutionHasMore(newItems.length > 0);
            setFacebookByStateInstitutionPage(page);
        } catch (error) {
            setFacebookByStateInstitutionHasMore(false);
        }
        setFacebookByStateInstitutionLoading(false);
    };

    const fetchYtByDateNonParlamentary = async (page = 1) => {
        setYoutubeByDateNonParlamentaryLoading(true);
        try {
            const response = await fetch(`https://www.teraz.sk/api/social_network_content/list.php?pageIdx=${page}`);
            const data = await response.json();
            const newItems = data.YOUTUBE?.NON_PARLIAMENT_SUBJECT?.by_date || [];
            const filteredItems = newItems.filter(item => item.network_type === 'YOUTUBE');
            
            setYoutubeByDateNonParlamentary(prev => [...prev, ...filteredItems]);
            setYoutubeByDateNonParlamentaryHasMore(filteredItems.length > 0);
            setYoutubeByDateNonParlamentaryPage(page);
        } catch (error) {
            setYoutubeByDateNonParlamentaryHasMore(false);
        }
        setYoutubeByDateNonParlamentaryLoading(false);
    };

    const fetchFacebookByDateNonParlamentary = async (page = 1) => {
        setFacebookByDateNonParlamentaryLoading(true);
        try {
            const response = await fetch(`https://www.teraz.sk/api/social_network_content/list.php?pageIdx=${page}`);
            const data = await response.json();
            const newItems = data.FACEBOOK?.NON_PARLIAMENT_SUBJECT?.by_date || [];
            const filteredItems = newItems.filter(item => item.network_type === 'FACEBOOK');
            setFacebookByDateNonParlamentary(prev => [...prev, ...filteredItems]);
            setFacebookByDateNonParlamentaryHasMore(filteredItems.length > 0);
            setFacebookByDateNonParlamentaryPage(page);
        } catch (error) {
            setFacebookByDateNonParlamentaryHasMore(false);
        }
        setFacebookByDateNonParlamentaryLoading(false);
    };

    const fetchInstagramByDateNonParlamentary = async (page = 1) => {
        setInstagramByDateNonParlamentaryLoading(true);
        try {
            const response = await fetch(`https://www.teraz.sk/api/social_network_content/list.php?pageIdx=${page}`);
            const data = await response.json();
            const newItems = data.INSTAGRAM?.NON_PARLIAMENT_SUBJECT?.by_date || [];
            const filteredItems = newItems.filter(item => item.network_type === 'INSTAGRAM');
            setInstagramByDateNonParlamentary(prev => [...prev, ...filteredItems]);
            setInstagramByDateNonParlamentaryHasMore(filteredItems.length > 0);
            setInstagramByDateNonParlamentaryPage(page);
        } catch (error) {
            setInstagramByDateNonParlamentaryHasMore(false);
        }
        setInstagramByDateNonParlamentaryLoading(false);
    };

    useEffect(() => {
        const handleScroll = () => {
            const viewsEl = ytByViewsRef.current;
            const dateEl = ytByDateRef.current;
            const spotifyEl = spotifyByDateRef.current;
            const instagramEl = instagramByDateRef.current;
            const facebookEl = facebookByDateRef.current;
            const facebookStateInstitutionEl = facebookByStateInstitutionRef.current;
            const youtubeByDateNonParlamentaryEl = youtubeByDateNonParlamentaryRef.current;
            const facebookByDateNonParlamentaryEl = facebookByDateNonParlamentaryRef.current;
            const instagramByDateNonParlamentaryEl = instagramByDateNonParlamentaryRef.current;
            // Handle views scroll
            if (viewsEl && !ytByViewsLoading && ytByViewsHasMore) {
                if (viewsEl.scrollTop + viewsEl.clientHeight >= viewsEl.scrollHeight - 10) {
                    fetchYtByViews(ytByViewsPage + 1);
                }
            }

            // Handle date scroll
            if (dateEl && !ytByDateLoading && ytByDateHasMore) {
                if (dateEl.scrollTop + dateEl.clientHeight >= dateEl.scrollHeight - 10) {
                    fetchYtByDate(ytByDatePage + 1);
                }
            }

            // Handle spotify scroll
            if (spotifyEl && !spotifyByDateLoading && spotifyByDateHasMore) {
                if (spotifyEl.scrollTop + spotifyEl.clientHeight >= spotifyEl.scrollHeight - 10) {
                    fetchSpotifyByDate(spotifyByDatePage + 1);
                }
            }

            // Handle instagram scroll
            if (instagramEl && !instagramByDateLoading && instagramByDateHasMore) {
                if (instagramEl.scrollTop + instagramEl.clientHeight >= instagramEl.scrollHeight - 10) {
                    fetchInstagramByDate(instagramByDatePage + 1);
                }
            }

            // Handle facebook scroll
            if (facebookEl && !facebookByDateLoading && facebookByDateHasMore) {
                if (facebookEl.scrollTop + facebookEl.clientHeight >= facebookEl.scrollHeight - 10) {
                    fetchFacebookByDate(facebookByDatePage + 1);
                }
            }

            // Handle youtube non parlamentary scroll
            if (youtubeByDateNonParlamentaryEl && !youtubeByDateNonParlamentaryLoading && youtubeByDateNonParlamentaryHasMore) {
                if (youtubeByDateNonParlamentaryEl.scrollTop + youtubeByDateNonParlamentaryEl.clientHeight >= youtubeByDateNonParlamentaryEl.scrollHeight - 10) {
                    fetchYtByDateNonParlamentary(youtubeByDateNonParlamentaryPage + 1);
                }
            }

            // Handle facebook non parlamentary scroll
            if (facebookByDateNonParlamentaryEl && !facebookByDateNonParlamentaryLoading && facebookByDateNonParlamentaryHasMore) {
                if (facebookByDateNonParlamentaryEl.scrollTop + facebookByDateNonParlamentaryEl.clientHeight >= facebookByDateNonParlamentaryEl.scrollHeight - 10) {
                    fetchFacebookByDateNonParlamentary(facebookByDateNonParlamentaryPage + 1);
                }
            }

            // Handle instagram non parlamentary scroll
            if (instagramByDateNonParlamentaryEl && !instagramByDateNonParlamentaryLoading && instagramByDateNonParlamentaryHasMore) {
                if (instagramByDateNonParlamentaryEl.scrollTop + instagramByDateNonParlamentaryEl.clientHeight >= instagramByDateNonParlamentaryEl.scrollHeight - 10) {
                    fetchInstagramByDateNonParlamentary(instagramByDateNonParlamentaryPage + 1);
                }
            }

            // Handle facebook state institution scroll
            if (facebookStateInstitutionEl && !facebookByStateInstitutionLoading && facebookByStateInstitutionHasMore) {
                if (facebookStateInstitutionEl.scrollTop + facebookStateInstitutionEl.clientHeight >= facebookStateInstitutionEl.scrollHeight - 10) {
                    fetchFacebookByStateInstitution(facebookByStateInstitutionPage + 1);
                }
            }
        };

        const viewsEl = ytByViewsRef.current;
        const dateEl = ytByDateRef.current;
        const spotifyEl = spotifyByDateRef.current;
        const instagramEl = instagramByDateRef.current;
        const facebookEl = facebookByDateRef.current;
        const facebookStateInstitutionEl = facebookByStateInstitutionRef.current;
        const youtubeByDateNonParlamentaryEl = youtubeByDateNonParlamentaryRef.current;
        const facebookByDateNonParlamentaryEl = facebookByDateNonParlamentaryRef.current;
        const instagramByDateNonParlamentaryEl = instagramByDateNonParlamentaryRef.current;
        if (viewsEl) viewsEl.addEventListener('scroll', handleScroll);
        if (dateEl) dateEl.addEventListener('scroll', handleScroll);
        if (spotifyEl) spotifyEl.addEventListener('scroll', handleScroll);
        if (instagramEl) instagramEl.addEventListener('scroll', handleScroll);
        if (facebookEl) facebookEl.addEventListener('scroll', handleScroll);
        if (facebookStateInstitutionEl) facebookStateInstitutionEl.addEventListener('scroll', handleScroll);
        if (youtubeByDateNonParlamentaryEl) youtubeByDateNonParlamentaryEl.addEventListener('scroll', handleScroll);
        if (facebookByDateNonParlamentaryEl) facebookByDateNonParlamentaryEl.addEventListener('scroll', handleScroll);
        if (instagramByDateNonParlamentaryEl) instagramByDateNonParlamentaryEl.addEventListener('scroll', handleScroll);
        return () => {
            if (viewsEl) viewsEl.removeEventListener('scroll', handleScroll);
            if (dateEl) dateEl.removeEventListener('scroll', handleScroll);
            if (spotifyEl) spotifyEl.removeEventListener('scroll', handleScroll);
            if (instagramEl) instagramEl.removeEventListener('scroll', handleScroll);
            if (facebookEl) facebookEl.removeEventListener('scroll', handleScroll);
            if (facebookStateInstitutionEl) facebookStateInstitutionEl.removeEventListener('scroll', handleScroll);
            if (youtubeByDateNonParlamentaryEl) youtubeByDateNonParlamentaryEl.removeEventListener('scroll', handleScroll);
            if (facebookByDateNonParlamentaryEl) facebookByDateNonParlamentaryEl.removeEventListener('scroll', handleScroll);
            if (instagramByDateNonParlamentaryEl) instagramByDateNonParlamentaryEl.removeEventListener('scroll', handleScroll);
        };
    }, [
        ytByViewsLoading, 
        ytByViewsHasMore, 
        ytByViewsPage,
        ytByDateLoading,
        ytByDateHasMore,
        ytByDatePage,
        spotifyByDateLoading,
        spotifyByDateHasMore,
        spotifyByDatePage,
        instagramByDateLoading,
        instagramByDateHasMore,
        instagramByDatePage,
        facebookByDateLoading,
        facebookByDateHasMore,
        facebookByDatePage,
        facebookByStateInstitutionLoading,
        facebookByStateInstitutionHasMore,
        facebookByStateInstitutionPage,
        youtubeByDateNonParlamentaryLoading,
        youtubeByDateNonParlamentaryHasMore,
        youtubeByDateNonParlamentaryPage,
        facebookByDateNonParlamentaryLoading,
        facebookByDateNonParlamentaryHasMore,
        facebookByDateNonParlamentaryPage,
        instagramByDateNonParlamentaryLoading,
        instagramByDateNonParlamentaryHasMore,
        instagramByDateNonParlamentaryPage
    ]);

  return (
    <div>
        <div className="container static-page ass">  
            <div className="text-center">
                <h1>Politika na sociálnych sieťach</h1>
            </div>                          
            
            {showSearchPopup && (process.env.BUILD_TARGET !== "server") &&
            <div className="search-popup">
                <div className="inner" style={{ marginTop: `${window.scrollY}px` }}>
                    <div className="close-popup" onClick={() => setShowSearchPopup(false)}>Zavrieť</div>
                    <div className="search-group first">
                        <div className="subtitle">Vyhľadajte vo videách</div>
                        <form className="search-form"
                            onSubmit={(e) => {
                                e.preventDefault();
                                const searchQuery = e.target.elements['search-yt'].value;
                                handleSearchVideo(searchQuery);
                                setShowSearchPopup(false);
                                if (process.env.BUILD_TARGET !== "server") {
                                    window.scrollTo({
                                        top: document.querySelector('.anch-videos')?.offsetTop - 100,
                                        behavior: 'smooth'
                                    });
                                }
                            }}
                        >
                            <input type="text" name="search-yt" placeholder="Hľadaný výraz" id="" />
                            <button type="submit">
                                <i className="icon icon-search light sm"></i>
                            </button>
                        </form>
                    </div>                    

                    <div className="search-group">
                        <div className="subtitle">Vyhľadajte v príspevkoch</div>
                        <form className="search-form"
                            onSubmit={(e) => {
                                e.preventDefault();
                                const searchQuery = e.target.elements['search-posts'].value;
                                handleSearch(searchQuery);
                                setShowSearchPopup(false);
                                if (process.env.BUILD_TARGET !== "server") {
                                    window.scrollTo({
                                        top: document.querySelector('.anch-posts')?.offsetTop - 100,
                                        behavior: 'smooth'
                                    });
                                }
                            }}
                        >
                            <input type="text" name="search-posts" placeholder="Hľadaný výraz" id="" />
                            <button type="submit">
                                <i className="icon icon-search light sm"></i>
                            </button>
                        </form>
                    </div>
                </div>
            </div>
            }
            
            {showPopup && (process.env.BUILD_TARGET !== "server") &&
            <div className={"embedded-post-popup " + (embeddedFbPost && 'fb-post')}>
                <div className="inner" style={{ marginTop: `${window.scrollY}px` }}>
                    <div className="close-popup" onClick={() => closePopup()}>Zavrieť</div>
                    {embeddedFbPost && (
                        <FacebookEmbed
                            url={embeddedFbPost}
                            width={window.innerWidth <= 600 ? '100%' : 800}
                            frame={window}
                        />
                    )}
                    {embeddedIgPost && <InstagramEmbed url={embeddedIgPost} width={450}  />}
                    {embeddedYtPost && <YouTubeEmbed url={embeddedYtPost} width={500} />}
                    {embeddedSpotifyPost && <div id="spotify-player"><SpotifyPlayer embedUrl={embeddedSpotifyPost} /></div>}
                </div>                  
            </div>
            }
            
            <div className="ass-page-wrapper ass-2-cols">
                <div className="row-ass">
                    <div className="col-ass">
                        <div className="top-col">
                            <i className="icon icon-yt"></i>
                            <div className="text">
                                <div className="title">YouTube - Najsledovanejšie videá</div>
                                {/* <div className="desc">za posledných 24 hodín</div> */}
                                <div className="desc">za posledných 7 dní</div>
                            </div>
                        </div>

                        <div className="ass-banner-list" ref={ytByViewsRef}>
                            {ytByViews.map((item, index) => (
                                <div className="ass-banner-item yt" onClick={() => openEmbedPopup(item.url, item.network_type)} key={index}>
                                    <div
                                        className={`img-wrapper ${item.thumbnail == '' ? 'no-img' : ''}`}
                                        style={{ backgroundImage: `url(${item.thumbnail})` }}
                                    ></div>
                                    <div className="text">
                                        <div className="title xl">
                                            {item.title && item.title.length > 0 ? (item.title.length > 55 ? item.title.substring(0, 55) + "..." : item.title) : item.creator_name}
                                        </div>
                                        <div className="meta"> {formatDate(item.remote_created)} | {item.creator_handle} | {item.views} zobrazení</div>
                                    </div>
                                </div>
                            ))}
                            {ytByViewsLoading && <div className="item-list-loading">Načítavam...</div>}
                        </div>
                    </div>

                    <div className="col-ass">
                    <div className="top-col">
                        <i className="icon icon-yt"></i>
                        <div className="text">
                            <div className="title">YouTube - Najnovšie videá</div>
                        </div>
                    </div>

                    <div className="ass-banner-list" ref={ytByDateRef}>
                        {ytByDate.map((item, index) => (
                            <div className="ass-banner-item yt" onClick={() => openEmbedPopup(item.url, item.network_type)} key={index}>
                                <div
                                    className={`img-wrapper ${item.thumbnail == '' ? 'no-img' : ''}`}
                                    style={{ backgroundImage: `url(${item.thumbnail})` }}
                                ></div>
                                <div className="text">
                                    <div className="title xl">
                                        {item.title && item.title.length > 0 ? (item.title.length > 55 ? item.title.substring(0, 55) + "..." : item.title) : item.creator_name}
                                    </div>
                                    <div className="meta"> {formatDate(item.remote_created)} | {item.creator_handle} | {item.views} zobrazení</div>
                                </div>
                            </div>
                        ))}
                        {ytByDateLoading && <div className="item-list-loading">Načítavam...</div>}
                    </div>
                </div>  
                </div>                

                

                <div className="anch-videos"></div>
                <div className="col-search-bar">
                    <div className="title">
                        <i className="icon icon-search"></i>
                        <span>Vyhľadávanie vo videách</span>
                    </div>
                    <form
                        className="search-form"
                        onSubmit={(e) => {
                            e.preventDefault();
                            const searchQuery = e.target.elements['search-yt'].value;
                            handleSearchVideo(searchQuery);
                        }}
                    >
                        <div className="input-wrapper">
                            <input type="text" name="search-yt" placeholder="Hľadaný výraz" id="" />
                            <button type="submit">
                                <i className="icon icon-search sm"></i>
                            </button>
                        </div>
                    </form>

                    <ul className="filter-bar">
                        <li>
                            <div
                                className={`filter-toggle ${activeVideoFilter === "last3days" ? "active" : ""}`}
                                onClick={() => handleVideoFilterToggle("last3days")}
                            >
                                Posledné 3 dni
                            </div>
                        </li>
                        <li>
                            <div
                                className={`filter-toggle ${activeVideoFilter === "lastweek" ? "active" : ""}`}
                                onClick={() => handleVideoFilterToggle("lastweek")}
                            >
                                Posledný týždeň
                            </div>
                        </li>
                        <li>
                            <div
                                className={`filter-toggle ${activeVideoFilter === "lastmonth" ? "active" : ""}`}
                                onClick={() => handleVideoFilterToggle("lastmonth")}
                            >
                                Posledný mesiac
                            </div>
                        </li>
                    </ul>
                </div>

                { searchVideoTerm != '' &&
                <div className="ass-search-results-wrapper">
                    <div className="title">Výsledky vyhľadávania pre výraz "{searchVideoTerm}":</div>

                    { searchVideoResults.length > 0 ? (
                    <div className="search-results-list">
                    
                        {searchVideoResults.map((item, index) => (
                                <div 
                                    onClick={() => openEmbedPopup(item.url, item.networkType)}
                                    className={'search-result-item ' + item.networkType} key={index}>
                                    <div
                                        className={`img-wrapper ${item.thumbnail == '' ? 'no-img' : ''}`}
                                        style={{ backgroundImage: `url(${item.thumbnail})` }}
                                    ></div>
                                    <div className="text">
                                        <div className="title">
                                            {item.title.length > 120
                                                ? item.title.substring(0, 120) + '...'
                                                : item.title}
                                        </div>
                                        {item.text_content && (
                                            <div className="desc">
                                                {item.text_content.length > 120
                                                    ? item.text_content.substring(0, 120) + '...'
                                                    : item.text_content}
                                            </div>
                                        )}
                                    </div>
                                </div>
                        ))}
                    </div>
                    ): (
                        <div>
                            Ľutujeme, nenašli sa žiadne výsledky pre Váš hľadaný výraz.
                        </div>
                    )}
                
                </div>                
                }
                              
            </div>                    

            <div className="ass-page-wrapper first ass-4-cols">
                <div className="row-ass">
                    {/* <div className="col-ass">
                        <div className="top-col">
                            <i className="icon icon-spotify"></i>
                            <div className="text">
                                <div className="title">Spotify</div>
                                <div className="desc">Najnovšie podcasty</div>
                            </div>
                        </div>

                        <div className="ass-banner-list bg" ref={spotifyByDateRef}>
                            {spotifyByDate.map((item, index) => (
                                    <div className="ass-banner-item sm" onClick={() => openEmbedPopup(item.social_network_id, item.network_type)} key={index}>
                                    <div
                                        className={`img-wrapper circle ${item.thumbnail == '' ? 'no-img' : ''}`}
                                        style={{ backgroundImage: `url(${item.thumbnail})` }}
                                    ></div>
                                    <div className="text">
                                        <div className="title">
                                            {item.title.length > 55 ? item.title.substring(0, 55) + "..." : item.title}
                                        </div>
                                    </div>
                                    </div>
                                ))}
                            {spotifyByDateLoading && <div className="item-list-loading">Načítavam...</div>}
                        </div>                        

                    </div> */}

                    {/* <div className="col-ass">
                        <div className="top-col">
                            <i className="icon icon-threads"></i>
                            <div className="text">
                                <div className="title">Najnovšie statusy</div>
                            </div>
                        </div>

                        <div className="ass-banner-list bg">
                            {socialData?.THREADS?.by_date?.slice(0, 6).map((item, index) => (
                                <div className="ass-banner-item sm" onClick={() => openEmbedPopup(item.url, item.network_type)} key={index}>
                                <div
                                    className={`img-wrapper ${item.thumbnail == '' ? 'no-img' : ''}`}
                                    style={{ backgroundImage: `url(${item.thumbnail})` }}
                                ></div>
                                <div className="text">
                                    <div className="title">
                                        {item.title.length > 55 ? item.title.substring(0, 55) + "..." : item.title}
                                    </div>
                                </div>
                                </div>
                            ))}
                        </div>

                    </div> */}
                    
                    <div className="col-ass">
                        <div className="top-col icon-top">
                            <i className="icon icon-fb"></i>
                            <div className="text">
                                <div className="title">Facebook</div>
                                {/* <div className="desc">Najnovšie statusy</div> */}
                                <div className="desc">Najnovšie politické statusy</div>
                            </div>
                        </div>

                        <div className="ass-banner-list bg" ref={facebookByDateRef}>
                            {facebookByDate.map((item, index) => (
                                <div className="ass-banner-item sm" onClick={() => openEmbedPopup(item.url, item.network_type)} key={index}>
                                    <div
                                        className={`img-wrapper ${item.thumbnail == '' ? 'no-img' : ''}`}
                                        style={{ backgroundImage: `url(${item.thumbnail})` }}
                                    ></div>
                                    <div className="text">
                                        <div className="profile-name">{item.creator_handle}</div>
                                        <div className="title">
                                        {item.title && item.title.length > 0 ? (item.title.length > 55 ? item.title.substring(0, 55) + "..." : item.title) : item.creator_name}
                                        </div>
                                    </div>
                                </div>
                            ))}
                            {facebookByDateLoading && <div className="item-list-loading">Načítavam...</div>}
                        </div>
                    </div>

                    <div className="col-ass">
                        <div className="top-col icon-top">
                            <i className="icon icon-fb"></i>
                            <div className="text">
                                <div className="title">Facebook</div>
                                <div className="desc">Najnovšie statusy štátnych inštitúcií</div>
                            </div>
                        </div>

                        <div className="ass-banner-list bg" ref={facebookByStateInstitutionRef}>
                            {facebookByStateInstitution.map((item, index) => (
                                <div className="ass-banner-item sm" onClick={() => openEmbedPopup(item.url, item.network_type)} key={index}>
                                    <div
                                        className={`img-wrapper ${item.thumbnail == '' ? 'no-img' : ''}`}
                                        style={{ backgroundImage: `url(${item.thumbnail})` }}
                                    ></div>
                                    <div className="text">
                                        <div className="profile-name">{item.creator_handle}</div>
                                        <div className="title">
                                        {item.title && item.title.length > 0 ? (item.title.length > 55 ? item.title.substring(0, 55) + "..." : item.title) : item.creator_name}
                                        </div>
                                    </div>
                                </div>
                            ))}
                            {facebookByStateInstitutionLoading && <div className="item-list-loading">Načítavam...</div>}
                        </div>
                    </div>
                    

                    <div className="col-ass">
                        <div className="top-col icon-top">
                            <i className="icon icon-ig"></i>
                            <div className="text">
                                <div className="title">Instagram</div>
                                <div className="desc">Najnovšie príspevky</div>
                            </div>
                        </div>

                        <div className="ass-banner-list bg" ref={instagramByDateRef}>
                            {instagramByDate.map((item, index) => (
                                <div className="ass-banner-item sm" onClick={() => openEmbedPopup(item.url, item.network_type)} key={index}>
                                <div
                                    className={`img-wrapper ${item.thumbnail == '' ? 'no-img' : ''}`}
                                    style={{ backgroundImage: `url(${item.thumbnail})` }}
                                ></div>
                                <div className="text">
                                    <div className="profile-name">@{item.creator_handle}</div>
                                    <div className="title">
                                        {item.title.length > 55 ? item.title.substring(0, 55) + "..." : item.title}
                                    </div>
                                </div>
                                </div>
                            ))}
                            {instagramByDateLoading && <div className="item-list-loading">Načítavam...</div>}
                        </div>

                    </div>
                </div>

                <div className="anch-posts"></div>
                <div className="col-search-bar">
                    <div className="title">
                        <i className="icon icon-search"></i>
                        <span>Vyhľadávanie v príspevkoch</span>
                    </div>
                        <form
                            className="search-form"
                            onSubmit={(e) => {
                                e.preventDefault();
                                const searchQuery = e.target.elements['search-posts'].value;
                                handleSearch(searchQuery);
                            }}
                        >
                            <div className="input-wrapper">
                                <input type="text" name="search-posts" placeholder="Hľadaný výraz" id="" />
                                <button type="submit">
                                    <i className="icon icon-search sm"></i>
                                </button>
                            </div>
                        </form>

                    <ul className="filter-bar">
                        <li>
                            <div
                                className={`filter-toggle ${activePostFilter === "last3days" ? "active" : ""}`}
                                onClick={() => handleFilterToggle("last3days")}
                            >
                                Posledné 3 dni
                            </div>
                        </li>
                        <li>
                            <div
                                className={`filter-toggle ${activePostFilter === "lastweek" ? "active" : ""}`}
                                onClick={() => handleFilterToggle("lastweek")}
                            >
                                Posledný týždeň
                            </div>
                        </li>
                        <li>
                            <div
                                className={`filter-toggle ${activePostFilter === "lastmonth" ? "active" : ""}`}
                                onClick={() => handleFilterToggle("lastmonth")}
                            >
                                Posledný mesiac
                            </div>
                        </li>
                    </ul>
                </div>

                { searchTerm != '' &&
                <div className="ass-search-results-wrapper">
                    <div className="title">Výsledky vyhľadávania pre výraz "{searchTerm}":</div>

                    { searchResults.length > 0 ? (
                    <div className="search-results-list">
                    
                        {searchResults.map((item, index) => (                                
                            <div
                                onClick={() => openEmbedPopup(item.url, item.networkType)}
                                className={'search-result-item ' + item.networkType} key={index}>
                                <div
                                    className={`img-wrapper ${item.thumbnail == '' ? 'no-img' : ''}`}
                                    style={{ backgroundImage: `url(${item.thumbnail})` }}
                                ></div>
                                <div className="text">
                                    <div className="title">
                                        {item.title.length > 120
                                            ? item.title.substring(0, 120) + '...'
                                            : item.title}
                                    </div>
                                    {item.text_content && (
                                        <div className="desc">
                                            {item.text_content.length > 120
                                                ? item.text_content.substring(0, 120) + '...'
                                                : item.text_content}
                                        </div>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                    ): (
                        <div>
                            Ľutujeme, nenašli sa žiadne výsledky pre Váš hľadaný výraz.
                        </div>
                    )}
                
                </div>                
                }

            </div>

            <div className="ass-page-wrapper ass-4-cols">
                <div className="row-ass">                    
                    
                    <div className="col-ass">
                        <div className="top-col icon-top">
                            <i className="icon icon-yt"></i>
                            <div className="text">
                                <div className="title">YouTube - Najnovšie videá</div>                                
                                <div className="desc">Najnovšie politické statusy</div>                                
                                <div className="subtitle">Mimoparlamentné subjekty</div>
                            </div>
                        </div>

                        <div className="ass-banner-list bg" ref={youtubeByDateNonParlamentaryRef}>
                            {youtubeByDateNonParlamentary.map((item, index) => (
                                <div className="ass-banner-item sm" onClick={() => openEmbedPopup(item.url, item.network_type)} key={index}>
                                    <div
                                        className={`img-wrapper ${item.thumbnail == '' ? 'no-img' : ''}`}
                                        style={{ backgroundImage: `url(${item.thumbnail})` }}
                                    ></div>
                                    <div className="text">
                                        <div className="profile-name">{item.creator_handle}</div>
                                        <div className="title">
                                        {item.title && item.title.length > 0 ? (item.title.length > 55 ? item.title.substring(0, 55) + "..." : item.title) : item.creator_name}
                                        </div>
                                    </div>
                                </div>
                            ))}
                            {youtubeByDateNonParlamentaryLoading && <div className="item-list-loading">Načítavam...</div>}
                            {!youtubeByDateNonParlamentaryLoading && youtubeByDateNonParlamentary.length === 0 && <div className="item-list-loading">Nenašli sa žiadne príspevky</div>}
                        </div>
                    </div>

                    <div className="col-ass">
                        <div className="top-col icon-top">
                            <i className="icon icon-fb"></i>
                            <div className="text">
                                <div className="title">Facebook</div>                                
                                <div className="desc">Najnovšie statusy štátnych inštitúcií</div>                                
                                <div className="subtitle">Mimoparlamentné subjekty</div>
                            </div>
                        </div>

                        <div className="ass-banner-list bg" ref={facebookByDateNonParlamentaryRef}>
                            {facebookByDateNonParlamentary.map((item, index) => (
                                <div className="ass-banner-item sm" onClick={() => openEmbedPopup(item.url, item.network_type)} key={index}>
                                    <div
                                        className={`img-wrapper ${item.thumbnail == '' ? 'no-img' : ''}`}
                                        style={{ backgroundImage: `url(${item.thumbnail})` }}
                                    ></div>
                                    <div className="text">
                                        <div className="profile-name">{item.creator_handle}</div>
                                        <div className="title">
                                        {item.title && item.title.length > 0 ? (item.title.length > 55 ? item.title.substring(0, 55) + "..." : item.title) : item.creator_name}
                                        </div>
                                    </div>
                                </div>
                            ))}
                            {facebookByDateNonParlamentaryLoading && <div className="item-list-loading">Načítavam...</div>}
                            {!facebookByDateNonParlamentaryLoading && facebookByDateNonParlamentary.length === 0 && <div className="item-list-loading">Nenašli sa žiadne príspevky</div>}
                        </div>
                    </div>
                    

                    <div className="col-ass">
                        <div className="top-col icon-top">
                            <i className="icon icon-ig"></i>
                            <div className="text">
                                <div className="title">Instagram</div>                                
                                <div className="desc">Najnovšie príspevky</div>                                
                                <div className="subtitle">Mimoparlamentné subjekty</div>
                            </div>
                        </div>

                        <div className="ass-banner-list bg" ref={instagramByDateNonParlamentaryRef}>
                            {instagramByDateNonParlamentary.map((item, index) => (
                                <div className="ass-banner-item sm" onClick={() => openEmbedPopup(item.url, item.network_type)} key={index}>
                                <div
                                    className={`img-wrapper ${item.thumbnail == '' ? 'no-img' : ''}`}
                                    style={{ backgroundImage: `url(${item.thumbnail})` }}
                                ></div>
                                <div className="text">
                                    <div className="profile-name">@{item.creator_handle}</div>
                                    <div className="title">
                                        {item.title.length > 55 ? item.title.substring(0, 55) + "..." : item.title}
                                    </div>
                                </div>
                                </div>
                            ))}
                            {instagramByDateNonParlamentaryLoading && <div className="item-list-loading">Načítavam...</div>}
                            {!instagramByDateNonParlamentaryLoading && instagramByDateNonParlamentary.length === 0 && <div className="item-list-loading">Nenašli sa žiadne príspevky</div>}
                        </div>

                    </div>
                </div>

                <div className="anch-posts"></div>
                <div className="col-search-bar">
                    <div className="title">
                        <i className="icon icon-search"></i>
                        <span>Vyhľadávanie v príspevkoch</span>
                    </div>
                        <form
                            className="search-form"
                            onSubmit={(e) => {
                                e.preventDefault();
                                const searchQuery = e.target.elements['search-posts-non-parlamentary'].value;
                                handleSearchNonParlamentary(searchQuery);
                            }}
                        >
                            <div className="input-wrapper">
                                <input type="text" name="search-posts-non-parlamentary" placeholder="Hľadaný výraz" id="" />
                                <button type="submit">
                                    <i className="icon icon-search sm"></i>
                                </button>
                            </div>
                        </form>

                    <ul className="filter-bar">
                        <li>
                            <div
                                className={`filter-toggle ${activePostFilter === "last3days" ? "active" : ""}`}
                                onClick={() => handleFilterToggle("last3days")}
                            >
                                Posledné 3 dni
                            </div>
                        </li>
                        <li>
                            <div
                                className={`filter-toggle ${activePostFilter === "lastweek" ? "active" : ""}`}
                                onClick={() => handleFilterToggle("lastweek")}
                            >
                                Posledný týždeň
                            </div>
                        </li>
                        <li>
                            <div
                                className={`filter-toggle ${activePostFilter === "lastmonth" ? "active" : ""}`}
                                onClick={() => handleFilterToggle("lastmonth")}
                            >
                                Posledný mesiac
                            </div>
                        </li>
                    </ul>
                </div>

                { searchTermNonParlamentary != '' &&
                <div className="ass-search-results-wrapper">
                    <div className="title">Výsledky vyhľadávania pre výraz "{searchTermNonParlamentary}":</div>

                    { searchResultsNonParlamentary.length > 0 ? (
                    <div className="search-results-list">
                    
                        {searchResultsNonParlamentary.map((item, index) => (                                
                            <div
                                onClick={() => openEmbedPopup(item.url, item.networkType)}
                                className={'search-result-item ' + item.networkType} key={index}>
                                <div
                                    className={`img-wrapper ${item.thumbnail == '' ? 'no-img' : ''}`}
                                    style={{ backgroundImage: `url(${item.thumbnail})` }}
                                ></div>
                                <div className="text">
                                    <div className="title">
                                        {item.title.length > 120
                                            ? item.title.substring(0, 120) + '...'
                                            : item.title}
                                    </div>
                                    {item.text_content && (
                                        <div className="desc">
                                            {item.text_content.length > 120
                                                ? item.text_content.substring(0, 120) + '...'
                                                : item.text_content}
                                        </div>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                    ): (
                        <div>
                            Ľutujeme, nenašli sa žiadne výsledky pre Váš hľadaný výraz.
                        </div>
                    )}
                
                </div>                
                }

            </div>

            <div className="ass-page-socials">
                <div className="title">Sledujte nás na sociálnych sieťach</div>

                <ul>
                    <li><Link to={tasrTVVideaURL}><i className="icon icon-yt sm"></i><span>TASR TV Videá</span></Link></li>
                    <li><Link to={terazIgURL}><i className="icon icon-ig"></i><span>Teraz.sk</span></Link></li>
                    <li><Link to={tasrIgURL}><i className="icon icon-ig"></i><span>TASR.sk</span></Link></li>
                    {/* <li><Link to={terazThreadsURL}><i className="icon icon-threads"></i><span>Teraz.sk</span></Link></li> */}
                    <li><Link to={TerazFBUrl}><i className="icon icon-fb"></i><span>Teraz.sk</span></Link></li>
                    <li><Link to={tasrFBUrl}><i className="icon icon-fb"></i><span>TASR.sk</span></Link></li>
                    {/* <li><Link to={terazSCURL}><i className="icon icon-sc"></i><span>Teraz.sk</span></Link></li> */}
                </ul>
            </div>

            
           
        </div>
        

      <LoaderIndex />
    </div>
  );
};

export default AgregatorSocSietiPage;